import { render, staticRenderFns } from "./ActionTypeTemplateComponent.vue?vue&type=template&id=e24d8cb6&scoped=true&lang=pug"
import script from "./ActionTypeTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./ActionTypeTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./ActionTypeTemplateComponent.vue?vue&type=style&index=0&id=e24d8cb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d8cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24d8cb6')) {
      api.createRecord('e24d8cb6', component.options)
    } else {
      api.reload('e24d8cb6', component.options)
    }
    module.hot.accept("./ActionTypeTemplateComponent.vue?vue&type=template&id=e24d8cb6&scoped=true&lang=pug", function () {
      api.rerender('e24d8cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/ActionTypeTemplateComponent.vue"
export default component.exports